<div class="container">
  <div>
    <app-not-authorized-svg></app-not-authorized-svg>

    <h1 data-test-id="landing-page-header-text">
      Your account is not currently authorized to access this project
    </h1>

    <p data-test-id="landing-page-body-text">
      Please contact your Project Manager to request access
    </p>

    <div>
      <button mat-flat-button color="primary" (click)="logout()">
        Logout to continue
      </button>
    </div>
  </div>
</div>
